import React, { Component } from 'react';
import AppData from '../Model/AppData'
class LanguageSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {  };

        // Store list of pending Api calls and abort on unmount
        this.pendingApi = {}
    }
    componentDidMount() {
        this.loadCountrys()
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.isCountryLoaded && !this.languageDisplayed || prevState.selectedLanguage != this.state.selectedLanguage) {
            this.handleShowLanguageChoice()
        }
        if (!this.isCountryLoaded) {
            this.loadCountrys()
        }
    }
    handleShowLanguageChoice = () => {
        if (this.props.merchant && this.state.countryList) {
            this.languageDisplayed = true
            this.setState({ showChoices: this.showLanguageChoices() })
        }
    }
    componentWillUnmount() {
        Object.keys(this.pendingApi).forEach(id => {
            this.pendingApi[id] && this.pendingApi[id].abort()
            delete(this.pendingApi[id])
        })
    }
    onChangeLanguage(lang) {
        AppData.data && AppData.data.changeLanguage && AppData.data.changeLanguage(lang)
    }

    loadCountrys() {
        if (this.props.merchant) {
            console.log("loadCountrys")
            this.isCountryLoaded = true
            const randApiId = Math.random()
            this.pendingApi[randApiId] = $.ajax({
                url: "/country/list",
                type: "GET",
                success: allCountry => {
                    this.setState({
                        countryList: allCountry,
                        country: (allCountry && Array.isArray(allCountry) && allCountry || []).find( x => x.id == this.props.merchant.country_id )
                    }, this.handleShowLanguageChoice)
                },
                error: ajaxFails,
            })
            .done(() => {
                delete(this.pendingApi[randApiId])
            })
        }
    }

    showLanguageChoices = () => {
        // 0 - key to send to server
        // 1 - Text to display
        const langs = this.state.country ? this.state.country.language : [{"label":"English","value":"en"},{"label":"Chinese","value":"zn"},{"label":"Bahasa Melayu","value":"ms"}]

        let options = langs.map( (x, index) => {
            return (
                <li key={x.value} onClick={() => {this.onChangeLanguage(x.value); this.setState({ selectedLanguage: x.label })}}>
                    <a href="#">{x.label}</a>
                </li>
            )
        })

        let lang = langs.find(item => item.value == (window.selectedLang || 'en'))
        return (
            <div className="dropdown">
                <button className="btn btn-sm btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style={{border:"0px"}}>
                <span>{this.state.selectedLanguage || lang.label }</span>
                <span style={{display:"inline-block", marginLeft:"5px"}} className="caret"></span>
                </button>
                <ul className="dropdown-menu" style={{minWidth: "100px"}} aria-labelledby="dropdownMenu1">
                    {options}
                </ul>
            </div>
        )
    }
    render() {
        return (
            <div style={{display:"inline-block"}}>    
                {this.state.showChoices}
            </div>
        );
    }
}

export default LanguageSelect;